module.exports = __webpack_public_path__ + "img/icon_dashboard_service.448cec70.svg";